<template>
  <paginate
      class="pagination"
      :page-count="pageCount"
      :click-handler="clickHandler"
      :prev-text="prevText"
      :next-text="nextText">
  </paginate>
</template>

<script>
  import Paginate from 'vuejs-paginate';
  export default {
    props: ['pageCount', 'clickHandler'],
    components: {
      Paginate
    },
    data() {
      return {
        prevText: `<svg enable-background="new 0 0 240.823 240.823" version="1.1" viewBox="0 0 240.823 240.823" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><path d="m57.633 129.01l108.3 108.26c4.752 4.74 12.451 4.74 17.215 0 4.752-4.74 4.752-12.439 0-17.179l-99.707-99.671 99.695-99.671c4.752-4.74 4.752-12.439 0-17.191-4.752-4.74-12.463-4.74-17.215 0l-108.3 108.26c-4.679 4.691-4.679 12.511 0.012 17.191z"/></svg>`,
        nextText: `<svg enable-background="new 0 0 240.823 240.823" version="1.1" viewBox="0 0 240.823 240.823" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><path d="m183.19 111.82l-108.3-108.26c-4.752-4.74-12.451-4.74-17.215 0-4.752 4.74-4.752 12.439 0 17.179l99.707 99.671-99.695 99.671c-4.752 4.74-4.752 12.439 0 17.191 4.752 4.74 12.463 4.74 17.215 0l108.3-108.26c4.68-4.691 4.68-12.511-0.012-17.19z"/></svg>`
      }
    }
  }
</script>

<style lang="scss">
  @import './../../styles/variables.scss';
  .pagination {
    display: flex;
    padding: 20px;
    padding-left: 0;
    list-style-type: none;
    line-height: 1.7;
    font-size: 16px;

    svg {
      display: flex;
      width: 25px;
      fill: #3d3df3;
    }

    > li {
      display: flex;
      flex-direction: column;
      justify-content: center;
      border-radius: 2px;
      text-align: center;
      vertical-align: top;
      height: 30px;
      cursor: pointer;
      background-color: $light-blue;
      overflow: hidden;
      margin-right: 3px;
      outline: none;

      &:hover {
        background-color: #e5e5e5;
      }

      &:last-child {
        margin-right: 0;
      }

      .dark & {
        background-color: $bg-grey;

        &:hover {
          background-color: $dark-text;
        }
      }

      > a {
        color: #444;
        text-decoration: none !important;
        display: inline-block;
        padding: 0 10px;
        line-height: 30px;
        outline: none;

        > i {
          color: #444 !important;
        }

        .dark & {
          color: $dark-grey;
        }
      }
    }

    > li.active {
      background-color: #3847d8;

      > a {
        color: #fff !important;
      }
    }

    > li.disabled {
        display: none;
      > a {
        cursor: default;
        color: #999 !important;

        > i {
          color: #999 !important;
        }
      }
    }
  }
</style>